/**
 * Pattern Loader Setup
 * 
 * This file sets up a global function to load patterns from the sharing interface
 * into the main pattern editor in app.js
 */

// This function should be called when app.js initializes
export function setupPatternLoader(loadPatternFunction) {
  // Make the pattern loading function globally available
  window.loadPatternIntoEditor = (patternData) => {
    if (typeof loadPatternFunction === 'function') {
      loadPatternFunction(patternData);
      return true;
    }
    return false;
  };
  
  // For debugging
  console.log('Pattern loader function registered successfully');
  
  // Return a cleanup function
  return () => {
    window.loadPatternIntoEditor = null;
  };
}

// Function to check if the pattern loader is available
export function isPatternLoaderAvailable() {
  return typeof window.loadPatternIntoEditor === 'function';
} 